// src/utils/holderSnapshotFactory.js

import {
    resolveHolder,
    getHolderDisplayName
} from "./holderResolver";

import {
    normalizeHolderType
} from "./assets/holderUtils";

/**
 * Enterprise-safe immutable holder snapshot creator
 */
export const createHolderSnapshot = ({
    holderType,
    holderId,
    collection = [],
    snapshotSource = "SYSTEM"
}) => {

    // ==========================================
    // NORMALIZATION
    // ==========================================

    const normalizedType =
        normalizeHolderType(
            holderType
        );

    // ==========================================
    // HOLDER RESOLUTION
    // ==========================================

    const resolvedHolder =
        resolveHolder({
            holderType:
                normalizedType,

            holderId,
            collection
        });

    // ==========================================
    // HOLDER DISPLAY NAME
    // ==========================================

    const holderName =
        getHolderDisplayName({
            holderType:
                normalizedType,

            holderId,
            collection
        });

    // ==========================================
    // IMMUTABLE SNAPSHOT
    // ==========================================

    return {

        holder_type:
            normalizedType || "",

        holder_id:
            holderId || "",

        holder_name:
            holderName || "",

        snapshot_source:
            snapshotSource,

        snapshot_status:
            resolvedHolder
                ? "RESOLVED"
                : "MISSING",

        snapshot_missing:
            !resolvedHolder,

        snapshot_version:
            1,

        snapshot_created_at:
            new Date().toISOString()

    };

};